import { Component, OnInit } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbDateStruct, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from 'src/app/core/api.service';
import { UtilityService } from 'src/app/core/global/utility.service';
import { FunctionsService } from 'src/app/core/global/functions.service';
import { CONFIG } from '../../core/config';


@Component({
  selector: 'app-profile-model',
  templateUrl: './profile-model.component.html',
  styleUrls: ['./profile-model.component.sass']
})
export class ProfileModelComponent implements OnInit {
  profile: any = {};
  pass: any = {};
  updateId = '';
  userType;
  emp_profile = ''
  imageMainUrl;
  user;
  files: File[] = [];
  profileImg
  url;
  ids
  fileType
  imagefile = [];
  // userEmail:any={};

  constructor(public activeModal: NgbActiveModal,
    private modalService: NgbModal, private _adminService: ApiService, private _utility: UtilityService, private _functions: FunctionsService) { }

  ngOnInit(): void {
    this.userType = localStorage.getItem('m_ind_type');
    this.imageMainUrl = CONFIG.API_PROFILE_PICTURE;
    this.updateId = window.localStorage.getItem('');
    //alert(this.updateId);
    window.localStorage.removeItem('');
    this.getEmp();
  }

  openImage(src: string): void {
    // open lightbox3
    let data = [];
    data.push({ src: src, caption: '', thumb: src });
  }

  getEmp() {
    let data = { 'empId': this.updateId };
    let url = "emp/profile";
    this._adminService.post(url, data).subscribe((response) => {
      if (response.success == true) {
        this.profile.name = response.data[0].name;
        this.profile.email = response.data[0].email;
        this.profileImg = response.emp_profilepic[0].emp_profilepic;
        if (this.profileImg != '' && this.profileImg != null && this.profileImg != undefined) {
          this.emp_profile = this.profileImg
        } else {
        }
      }
      // this.userEmail=this.profile.email;
    })
  }


  update() {
    var error = 0;
    if (!this.profile.name) {
      error++;
      this._utility.toastWarning('Enter Your Name');
    }
    if (error == 0) {
      let url = 'emp/profile/save';
      if (this.userType == 'Org Admin' || 'Plant Admin') {
        this.profile.type = this.userType;
      }
      this._adminService.post(url, this.profile).subscribe((response) => {

        if (response.success == true) {
          localStorage.setItem('m_ind_name', this.profile.name)//m_ind_name
          if (this.imagefile.length > 0) {
            this.profileImage(response.data, 1)
          }
          this._utility.toastSuccess(response.message);
          this.activeModal.close(true);
        } else {
          this._utility.toastError(response.message);
        }
      })
    }
  }

  updatePassword() {
    var error = 0;
    if (this.pass.oldPassword == '') {
      error++;
      this._utility.toastWarning('Enter Your Old Password');
    }
    else if (this.pass.newPassword == '') {
      error++;
      this._utility.toastWarning('Enter Your New Password');
    }
    else if (this.pass.confirmNewPassword == '') {
      error++;
      this._utility.toastWarning('Enter Your Confirm Password');
    }
    else if (this.pass.newPassword != this.pass.confirmNewPassword) {
      error++;
      this._utility.toastWarning('Your New Password and Confirm Password Did Not Match');
    }

    if (error == 0) {
      let url = 'emp/profile/password';
      if (this.userType == 'Org Admin' || 'Plant Admin') {
        this.pass.email = this.profile.email;
      }
      this._adminService.post(url, this.pass).subscribe((response) => {
        if (response.success == true) {
          if (this.imagefile.length > 0) {
            this.profileImage(response.data, 1)
          }
          this._utility.toastSuccess(response.message);
          this.activeModal.close(true);
        } else {
          this._utility.toastError(response.message);
        }
      })
    }
  }

  onSelectFile(event, fileType) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      this.files = []
      this.files.push(...event.target.files);
      if (fileType == 'Image') {
        this.fileType = 1;
        this.imagefile = []
        this.imagefile = this.files;
        if (this.imagefile.length > 0) {
          this._utility.toastWarning("click Save button to update your profile picture")
        }
      } else {
        this.fileType = 2;
      }
      reader.onload = (event) => {
        this.url = event.target.result;
        this.emp_profile = this.url;
      }
    }
  }
  profileImage(insertId, fileType) {
    const fd = new FormData();
    let url = 'users/profile-image'
    fd.append('id', this.ids);
    fd.append('filetype', fileType);
    if (fileType == 1) {
      if (this.imagefile.length > 0) {

        for (let i = 0; i < this.imagefile.length; i++) {
          fd.append('image', this.imagefile[i]);

        }
      }
    } else if (fileType == 2) {
    }
    this._adminService.photoUpload(url, fd).subscribe((res) => {
    });
  }
}
